import { useMeetingContext } from 'Context/MeetingContext';
import { useListContextDispatch, useListContextState } from 'Components/UI/ListDetailView/ListContext';

export default function useMissionControl() {
  const { meetingResource, setMeetingResource } = useMeetingContext();
  const { collection } = useListContextState();
  const listDispatch = useListContextDispatch();
  const hasMeetings = collection ? !collection.resources().empty() : false;

  return {
    initializing: !meetingResource,
    noMeetings: !hasMeetings,
    selectMeetingResource: async (resource) => {
      const [updatedMeetingResource] = await resource.link('self').get();
      listDispatch({ type: 'updateResource', resource: updatedMeetingResource });
      setMeetingResource(updatedMeetingResource);
    },
  };
}
